import { AgreementInterface, Order, UserInterface as SalesUser } from '@vendasta/sales-orders';

export class OrderDetailAgreement {
  name: string;
  term: string;
  agreed: boolean;

  static agreementFromOrderAgreementWithUser(
    agreement: AgreementInterface,
    usersMap: { [key: string]: SalesUser },
  ): OrderDetailAgreement {
    const names = [];
    let name = '';
    if (agreement.userId in usersMap) {
      const user = usersMap[agreement.userId];
      if (user.firstName) {
        names.push(user.firstName);
      }
      if (user.lastName) {
        names.push(user.lastName);
      }
      name = names.join(' ') || user.email;
    }
    return new OrderDetailAgreement(name, agreement.term, agreement.agreed);
  }

  public static createFromOrderWithUsers(
    salesOrder: Order,
    usersMap: { [key: string]: SalesUser },
  ): OrderDetailAgreement[] {
    if (!salesOrder) {
      return [];
    }
    if (!usersMap) {
      usersMap = {};
    }
    return (salesOrder.agreements || []).map((a) => {
      return OrderDetailAgreement.agreementFromOrderAgreementWithUser(a, usersMap);
    });
  }

  constructor(name: string, term: string, agreed: boolean) {
    this.name = name;
    this.term = term;
    this.agreed = agreed;
  }
}
